/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentUsage } from './providerComponentUsage';
import { ProviderComponentInventory } from './providerComponentInventory';
import { ProviderComponentHealth } from './providerComponentHealth';


/**
 * Combined inventory, its health and usage details IRR Proxy APIs response format
 */
export interface IrrComponentsData { 
    components_health: ProviderComponentHealth;
    components_list: ProviderComponentInventory;
    components_usage: ProviderComponentUsage;
}

